export const ACCOUNT_ROLES = { LEARNER: 'LEARNER', LEADER: 'LEADER', OWNER: 'OWNER' }
